import React from "react"

import Index from ".."

const Boston = () => <Index />

export default Boston
